module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-abf57188ab93e7721847a510efed7e5f.svg";